import axios from 'axios';
import { Event, CreateEventRequest, RegisterGuestRequest, LoginRequest, Guest } from '../types';

// const API_BASE_URL = 'http://localhost:5206/api';
const API_BASE_URL = 'https://daniekrieventpageapi.azurewebsites.net/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authApi = {
  login: async (request: LoginRequest): Promise<{ token: string }> => {
    const response = await api.post('/auth/login', request);
    return response.data;
  },
};

export const adminApi = {
  getAllEvents: async (): Promise<Event[]> => {
    const response = await api.get('/admin/events');
    return response.data;
  },

  createEvent: async (request: CreateEventRequest): Promise<Event> => {
    const response = await api.post('/admin/events', request);
    return response.data;
  },

  updateEvent: async (id: string, request: CreateEventRequest): Promise<Event> => {
    const response = await api.put(`/admin/events/${id}`, request);
    return response.data;
  },

  deleteEvent: async (id: string): Promise<void> => {
    await api.delete(`/admin/events/${id}`);
  },

  removeGuest: async (eventId: string, guestId: string): Promise<void> => {
    await api.delete(`/admin/events/${eventId}/guests/${guestId}`);
  },
};

export const publicApi = {
  getEvent: async (id: string): Promise<Event> => {
    const response = await api.get(`/events/${id}`);
    return response.data;
  },

  registerGuest: async (eventId: string, request: RegisterGuestRequest): Promise<Guest> => {
    const response = await api.post(`/events/${eventId}/register`, request);
    return response.data;
  },
};